export const PENDING_NOTIFICATION_PROMPT_SESSION_KEY = 'milora_pending_notification_prompt';

const STATE_KEY_PREFIX = 'milora_notification_prompt_state:';

export type NotificationPromptState = 'pending' | 'prompted' | 'registered' | 'dismissed';

function isNativeMiloraApp(): boolean {
  if (typeof window === 'undefined') return false;
  return Boolean(window.ReactNativeWebView) || navigator.userAgent.includes('MiloraApp');
}

export function markPendingNotificationPrompt(): void {
  try {
    sessionStorage.setItem(PENDING_NOTIFICATION_PROMPT_SESSION_KEY, '1');
  } catch {
    // ignore storage access errors
  }
}

/** Queue auto-prompt after auth only inside the React Native mobile app. */
export function markPendingNotificationPromptIfNative(): void {
  if (isNativeMiloraApp()) {
    markPendingNotificationPrompt();
  }
}

export function hasPendingNotificationPrompt(): boolean {
  try {
    return sessionStorage.getItem(PENDING_NOTIFICATION_PROMPT_SESSION_KEY) === '1';
  } catch {
    return false;
  }
}

export function clearPendingNotificationPrompt(): void {
  try {
    sessionStorage.removeItem(PENDING_NOTIFICATION_PROMPT_SESSION_KEY);
  } catch {
    // ignore storage access errors
  }
}

export function getNotificationPromptState(userId: string): NotificationPromptState | null {
  try {
    const raw = localStorage.getItem(`${STATE_KEY_PREFIX}${userId}`);
    if (raw === 'pending' || raw === 'prompted' || raw === 'registered' || raw === 'dismissed') {
      return raw;
    }
  } catch {
    // ignore storage access errors
  }
  return null;
}

export function setNotificationPromptState(userId: string, state: NotificationPromptState): void {
  try {
    localStorage.setItem(`${STATE_KEY_PREFIX}${userId}`, state);
  } catch {
    // ignore storage access errors
  }
}
